module.exports = __webpack_public_path__ + "img/4.f6387e05.png";